import { jsx as r } from "react/jsx-runtime";
import { Button as e } from "@datamole/wds-component-button";
import { faXmark as f } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as d } from "@fortawesome/react-fontawesome";
import { forwardRef as u } from "react";
import { useComboboxContext as b } from "../../hooks/use-combobox-context.js";
const x = u((n, i) => {
  const { children: m, onClick: a, ...l } = n, { value: o, disabled: s, onClear: c } = b(), p = (t) => {
    t.stopPropagation(), c(), a?.(t);
  };
  return o === null || Array.isArray(o) && o.length < 1 ? null : /* @__PURE__ */ r(
    e,
    {
      ...l,
      ref: i,
      type: "button",
      variant: "text",
      size: "sm",
      disabled: s,
      tabIndex: -1,
      onClick: p,
      children: /* @__PURE__ */ r(e.Icon, { children: m || /* @__PURE__ */ r(d, { icon: f }) })
    }
  );
});
x.displayName = "Combobox.Trigger.Remove";
export {
  x as Remove
};
